<template>
  <UiSkeleton
    :items="4"
    class-name="list-skeleton-item"
  />
</template>

<script>
export default {
  name: 'SkeletonList',
}
</script>

<style lang="scss" scoped>
::v-deep .list-skeleton-item {
  height: 320px;
  border-radius: 8px;

  @include media(tablet) {
    height: 400px;
  }

}
.skeleton{
  display: grid;
  gap: 24px;

  @include media(tablet){
    grid-template-columns: 1fr 1fr;
    gap: 16px;
  }

  @include media(desktop){
    gap: 24px;
  }

}
</style>
